/**
 *
 * Asynchronously loads the component for SubscriptionDetailPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const SubscriptionDetailPage = lazyLoad(
  () => import('./index'),
  module => module.default,
);
